import createBreakpoints from '@material-ui/core/styles/createBreakpoints';

export const breakpoints = createBreakpoints({});
export const spacing = 8;
